import React from 'react';
import i18n from '~/i18n';
import { Machine, MachineSearch, MachineSpecification } from '~/types';
import classes from './searchLabel.module.scss';

export const getMachineSubTitle = ({ intern, regNo }: Machine | MachineSpecification): string =>
  `ID: ${(intern || '').toUpperCase()} ${((regNo) ? ( ' | Reg.nr.: ' +  (regNo).toUpperCase()) : '')}` ;

const DRIVER_LABEL_KEYS: Record<string, string> = {
  fixedDriverName: 'documentation.specifications.fixedDriverName',
  currentDriverName: 'documentation.specifications.currentDriverName',
  driverName: 'documentation.specifications.driver',
};

const formatInternWithRole = (internLabel: string, roleKey: string, name: string): string =>
  `${internLabel} - ${i18n.t(DRIVER_LABEL_KEYS[roleKey])}: ${name}`.trim();

export const formatInternWithDriver = (
  {
    intern,
    assignedDriverName,
    fixedDriverName,
    currentDriverName,
    driverName,
    assignedDriverRole,
  }: {
    intern?: string;
    assignedDriverName?: string;
    fixedDriverName?: string;
    currentDriverName?: string;
    driverName?: string;
    assignedDriverRole?: string;
  },
  matchedKeys?: string[]
): string => {
  const internLabel = (intern || '').trim();

  if (matchedKeys?.length) {
    if (matchedKeys.includes('fixedDriverName') && (fixedDriverName || '').trim()) {
      return formatInternWithRole(internLabel, 'fixedDriverName', fixedDriverName!.trim());
    }
    if (matchedKeys.includes('currentDriverName') && (currentDriverName || '').trim()) {
      return formatInternWithRole(internLabel, 'currentDriverName', currentDriverName!.trim());
    }
    if (matchedKeys.includes('driverName') && (driverName || '').trim()) {
      return formatInternWithRole(internLabel, 'driverName', driverName!.trim());
    }
    if (matchedKeys.includes('assignedDriverName') && (assignedDriverName || '').trim()) {
      const name = (assignedDriverName || '').trim();
      return assignedDriverRole && DRIVER_LABEL_KEYS[assignedDriverRole]
        ? formatInternWithRole(internLabel, assignedDriverRole, name)
        : `${internLabel} - ${name}`.trim();
    }
  }

  return `${internLabel} - ${(assignedDriverName || '').trim() || 'N/A'}`.trim();
};

export const formatMachineSearchValue = ({ intern, name }: MachineSearch): string =>
  `${intern || ''} ${name || ''}`.trim();

export const formatMachineSearchLabel = (
  item: {
    name?: string;
    intern?: string;
    assignedDriverName?: string;
    fixedDriverName?: string;
    currentDriverName?: string;
    driverName?: string;
    assignedDriverRole?: string;
  },
  matchedKeys?: string[]
): React.ReactNode => (
  React.createElement(
    'div',
    { className: classes['search-label'] },
    React.createElement('div', { className: classes['search-label-main'] }, item.name || formatMachineSearchValue(item as MachineSearch)),
    React.createElement('div', { className: classes['search-label-driver'] }, formatInternWithDriver(item, matchedKeys))
  )
);
